<!-- Created by Maxim B. on 08/04/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->
<!--      TODO: ADD VALID IMAGE HERE    -->
<div class="wrapper">
  <div class="image-container">
    <img [src]="data.url" alt="">
    <curr-icon-button icon="close"  (click)="dialogRef.close()" class="close"></curr-icon-button>
  </div>
</div>
